export default __webpack_public_path__ + "static/const-six-cfdf8df928b8f3def0046f6e83773726.png";